<template>
  <div class="content">
    <div class="container-fluid">
      <div class="d-flex justify-content-center p-4">
        <card class="col-sm-8 col-xl-6">
          <!-- <h3 slot="header" class="card-title">Efetuar Login</h3> -->
          <div class="row">
            <div class="col-xl-6">
              <div class="row">
                <div class="col-12 text-center mb-2">
                  <h4>Login</h4>
                </div>
              </div>
              <form>
                <div class="row">
                  <div class="col-md-12">
                    <base-input
                      type="text"
                      label="Usuário"
                      placeholder="Usuário"
                      v-model="user.username"
                    ></base-input>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <base-input
                      type="password"
                      label="Senha"
                      placeholder="Senha"
                      v-model="user.password"
                    ></base-input>
                  </div>
                </div>

                <div class="text-center col-12">
                  <button
                    type="submit"
                    class="btn btn-fill btn-info w-50 mb-4"
                    @click.prevent="login"
                  >
                    Entrar
                  </button>
                </div>
                <div class="clearfix"></div>
              </form>
            </div>

            <div class="col-xl-6 ">
               <div class="row">
                <div class="col-12 text-center mb-2">
                  <h4>Consulta Rápida</h4>
                </div>
              </div>
              <consulta-unica></consulta-unica>
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import Card from "src/components/Cards/Card";
import ConsultaUnica from "src/components/exibicao/ConsultaUnica.vue";

export default {
  components: {
    Card,
    ConsultaUnica,
  },
  methods: {
    login() {
      var url = this.$urlApi + "/api/login";
      this.axios.post(url, this.user).then((res) => {
        let data = res.data;
        if (data.status) {
          console.log("Login efetuado com Sucesso!");
          sessionStorage.setItem("loginInfo", JSON.stringify(data));
          this.redirectAfter();
        } else {
          alert(data.msg);
          sessionStorage.removeItem("loginInfo");
        }
      });
    },
    redirectAfter() {
      this.$router.push("/webtrack/processos");
    },
    checkLoginStatus($json) {
      let checkLoginStatus = JSON.parse(sessionStorage.getItem("loginInfo"));

      if (checkLoginStatus != null || checkLoginStatus != undefined) {
        if (
          checkLoginStatus.hasOwnProperty("status") &&
          checkLoginStatus.status
        ) {
          this.redirectAfter();
        }
      }
    },
  },
  mounted() {
    this.checkLoginStatus();
  },
  data() {
    return {
      name: "Login",
      user: {
        username: "",
        password: "",
        email: "",
      },
    };
  },
};
</script>

<style lang="scss" scoped></style>
